"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var SurveyModelWrapper = /*#__PURE__*/function () {
  function SurveyModelWrapper(survey) {
    (0, _classCallCheck2.default)(this, SurveyModelWrapper);
    this.survey = survey;
    this.data = {};
  }
  (0, _createClass2.default)(SurveyModelWrapper, [{
    key: "valuesHash",
    get: function get() {
      return this.data;
    }
  }, {
    key: "isCurrentPageHasErrors",
    get: function get() {
      return this.survey.isCurrentPageHasErrors;
    }
  }, {
    key: "state",
    get: function get() {
      return this.survey.state;
    }
  }, {
    key: "currentPage",
    get: function get() {
      return this.survey.currentPage;
    }
  }, {
    key: "activePage",
    get: function get() {
      return this.survey.activePage;
    }
  }, {
    key: "getAllQuestions",
    value: function getAllQuestions() {
      var visibleOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var includingDesignTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.survey.getAllQuestions(visibleOnly, includingDesignTime);
    }
  }]);
  return SurveyModelWrapper;
}();
var _default = SurveyModelWrapper;
exports.default = _default;